import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useIsInSMSize } from "sketon/utility/DeviceInfo";
import styled from "styled-components";
import { BSIconText, BSIconTextLayoutMode } from "../Button/IconText";

const SytledWrapper = styled.div<{ paddingLeft?: string }>`
  width: fit-content;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: left;
  margin-top: 25px;
  padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : "0px")};

  cursor: pointer;
`;
export interface BSBackViewProps {
  paddingLeft?: string;

  backAction?: () => void;
}
export const BSBackView: React.FC<BSBackViewProps> = ({
  paddingLeft,
  backAction,
}) => {
  const darkMode = false;
  const isSMSize = useIsInSMSize();

  const navigate = useNavigate();
  const backFunc = useCallback(() => {
    if (backAction) {
      backAction();
    } else {
      navigate(-1);
    }
  }, [navigate, backAction]);

  return (
    <SytledWrapper paddingLeft={paddingLeft}>
      <BSIconText
        isBold={true}
        icon={
          darkMode
            ? require("assets/images/common/arrow/icon_arrow_left_gray.png")
            : require("assets/images/common/arrow/icon_arrow_left_gray.png")
        }
        iconSize={{
          h: isSMSize ? 0.36 : 1,
          w: isSMSize ? 0.36 : 1,
        }}
        hoIcon={
          darkMode
            ? require("assets/images/common/arrow/icon_arrow_left_black.png")
            : require("assets/images/common/arrow/icon_arrow_left_black.png")
        }
        space={"4px"}
        fontSize={isSMSize ? "13px" : "20px"}
        lineHeight={isSMSize ? "17px" : "25px"}
        text={"返回"}
        layoutMode={BSIconTextLayoutMode.ICON_LEFT}
        color={darkMode ? "rgba(17,17,17, 0.4)" : "rgba(17,17,17, 0.4)"}
        hocolor={darkMode ? "rgba(17,17,17, 0.8)" : "rgba(17,17,17, 0.8)"}
        background={"transparent"}
        hoBackground={"transparent"}
        flex="flex-start"
        padding="0 0px"
        borderRadius="0px"
        iconTopSpace="0px"
        click={backFunc}
      ></BSIconText>
    </SytledWrapper>
  );
};
